<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { type RouteLocationRaw, RouterLink } from "vue-router";

import config from "@/common/config";
import LogoAbc from "@/components/logo/LogoAbc.vue";
import { useAuthStore } from "@/stores";

const { isAuthenticated } = storeToRefs(useAuthStore());

const toRoute = computed<RouteLocationRaw>(() => {
  if (isAuthenticated.value) {
    return { name: "dictionary" };
  }

  return { name: "about" };
});
</script>

<template>
  <RouterLink class="site-logo" tabindex="0" :to="toRoute" :aria-label="config.site.label">
    <LogoAbc role="presentation" />
  </RouterLink>
</template>
